import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import React from 'react';
import ReactDOM from 'react-dom';

import ReactGallery from './react';


class Gallery extends WebComponent {

  didMount() {
    const images = JSON.parse(this.element.dataset.imgArr);
    ReactDOM.render((
      <ReactGallery images={images} {...this.props} />
    ), document.getElementById(this.element.id));

  }

  willUnMount() {
    ReactDOM.unmountComponentAtNode(this.element);
  }

}


export default Gallery;



// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/components/gallery/index.js